import { type TradeCompanyStatistics } from 'api';
import React from 'react';
import { Box, Stack, Typography, TypographyIcon } from 'ui';
import { AttachMoney, ShowChart, TrackChanges } from 'ui/icons';

import {
  DEFAULT_RECENT_DEALS_LOOKBACK_DAYS,
  DEFAULT_RECENT_OFFERS_LOOKBACK_DAYS,
  DEFAULT_RECENT_SIGNALS_LOOKBACK_DAYS,
} from '../../constants';

type Props = {
  title: string;
  statistics: TradeCompanyStatistics;
};

type StatisticLineProps = {
  icon: React.ElementType;
  label: string;
  totalCount: number;
  recentCount: number;
  recentLookbackDays: number;
};
const StatisticLine = ({ icon, label, totalCount, recentCount, recentLookbackDays }: StatisticLineProps) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <TypographyIcon icon={icon} size="small" variant="body2">
        {label}
      </TypographyIcon>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography>
          {recentCount} / {totalCount}
        </Typography>
        <Typography variant="body2" color="secondary.light">
          {recentLookbackDays}d / total
        </Typography>
      </Box>
    </Stack>
  );
};

export const TradeCompanyStatisticsCard = ({ title, statistics }: Props) => {
  const elems = [
    {
      icon: TrackChanges,
      label: 'Deals',
      recentCount: statistics.recent_deals_count,
      recentLookbackDays: DEFAULT_RECENT_DEALS_LOOKBACK_DAYS,
      totalCount: statistics.total_deals_count,
    },
    {
      icon: ShowChart,
      label: 'Signals',
      recentCount: statistics.recent_signals_count,
      recentLookbackDays: DEFAULT_RECENT_SIGNALS_LOOKBACK_DAYS,
      totalCount: statistics.total_signals_count,
    },
    {
      icon: AttachMoney,
      label: 'Offers',
      recentCount: statistics.recent_offers_count,
      recentLookbackDays: DEFAULT_RECENT_OFFERS_LOOKBACK_DAYS,
      totalCount: statistics.total_offers_count,
    },
  ];
  return (
    <Stack>
      <Typography variant="body2" fontWeight="bold">
        {title}
      </Typography>
      {elems.map((elem, index) => (
        <StatisticLine key={index} {...elem} />
      ))}
    </Stack>
  );
};
